import React from 'react';

export function PortalCard({ className = '', children }) {
  return <section className={`portal-card ${className}`.trim()}>{children}</section>;
}

export function PortalStat({ label, value, tone = 'default' }) {
  return (
    <PortalCard className={`portal-stat portal-stat-${tone}`}>
      <div className="portal-stat-label">{label}</div>
      <div className="portal-stat-value">{value}</div>
    </PortalCard>
  );
}

export function PortalButton({
  children,
  className = '',
  variant = 'primary',
  type = 'button',
  ...props
}) {
  return (
    <button
      type={type}
      className={`portal-button portal-button-${variant} ${className}`.trim()}
      {...props}
    >
      {children}
    </button>
  );
}

export function PortalInput({ label, className = '', ...props }) {
  return (
    <label className={`portal-field ${className}`.trim()}>
      {label ? <span className="portal-label">{label}</span> : null}
      <input className="portal-input" {...props} />
    </label>
  );
}

export function PortalTextarea({ label, className = '', ...props }) {
  return (
    <label className={`portal-field ${className}`.trim()}>
      {label ? <span className="portal-label">{label}</span> : null}
      <textarea className="portal-input portal-textarea" {...props} />
    </label>
  );
}

export function PortalSelect({ label, className = '', children, ...props }) {
  return (
    <label className={`portal-field ${className}`.trim()}>
      {label ? <span className="portal-label">{label}</span> : null}
      <select className="portal-input" {...props}>
        {children}
      </select>
    </label>
  );
}

export function PortalStatus({ children, tone = 'default' }) {
  return <span className={`portal-status portal-status-${tone}`}>{children}</span>;
}

export function PortalEmpty({ title, body }) {
  return (
    <PortalCard className="portal-empty">
      <h3>{title}</h3>
      <p>{body}</p>
    </PortalCard>
  );
}

export function PortalModal({ open, title, children, onClose }) {
  if (!open) {
    return null;
  }

  return (
    <div className="portal-modal-backdrop" onClick={onClose}>
      <div
        className="portal-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="portal-modal-header">
          <h3>{title}</h3>
          <button type="button" className="portal-modal-close" onClick={onClose}>
            x
          </button>
        </div>
        <div className="portal-modal-body">{children}</div>
      </div>
    </div>
  );
}
